import {useDispatch, useSelector} from 'react-redux';
import React, {useEffect, useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import _ from 'lodash';
import {Checkbox, DialogActions, TextField, Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import {useTranslation} from 'react-i18next';
import API from '../../../app/api';
import {setLoading} from '../../../store/reducers/additionalData';
import moment from 'moment';
import config from '../../../app/config';
import {globalVariable, setGlobalVariable, setSnackbar} from '../../../store/reducers/globals';
import {hasPermission, Permissions} from '../../../store/reducers/user';
import {useHistory} from 'react-router-dom';
import Grid from '@mui/material/Grid';
import AgyleSelectField from '../../../components/ui/selector/agyleSelectField';
import {FilterIcon3, SaveIcon2} from '../../../components/icons/icons';
import clsx from 'clsx';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
    cloneCurrentPref, patient as patientPreferences,
    patientCurrent as patientCurrentPreferences, savePref,
    setPatientCurrentPreference,
} from '../../../store/reducers/preferences';
import useOpenState from '../../../hooks/useOpenState';
import SearchIcon from '@mui/icons-material/Search';
import AgyleBlockSwitch from '../../../components/ui/switch/agyleBlockSwitch';
import {AgyleBoundingBoxIcon, AgyleMapViewIcon, CloseIcon} from '../../../components/icons/agyle';
import {EyonixFilterButton} from '../../patient/eyonixFilterButton';
import ListPatientsWithDocs from './listPatientsWithDocs';
import Patient, {PatientDetails, PatientVIPEyonixGuard} from '../../patient/patient';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import AgyleDialog from '../../../components/modal/agyleDialog';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import uuid from 'uuid/v4';
import AddIcon from '@mui/icons-material/Add';

const useStyles = makeStyles((theme) => ({
    advancedSearch: {
        backgroundColor: theme.palette.background.paper,
        padding: 10
    },
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    search: {
        display: "inline-flex",
        justifyContent: "center",
        width: "100%",
        backgroundColor: theme.palette.mode === "light" ? "#e3e3e3" : "#434343",
        padding: 10,
        alignItems: "center"
    },
    linksIcon: {
        position: "absolute",
        right: 15,
        top: 5
    },
    searchIcon: {
        display: "grid",
        alignItems: "center"
    },
    dialogContentStyle: {
          backgroundColor: theme.palette.mode === "dark" ? "#3D3E40" : "#ebebeb"
    },
    titleStyleDialog: {
        backgroundColor: theme.palette.mode === "dark" ? "#3D3E40 !important" : "#ebebeb !important"
    },
    groupedButton: {
        border: "1px solid white",
        padding: "5px 10px",
        fontSize: 13,
        height: 36,
        minWidth: 120,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        borderRadius: 25,
        margin: "0px 2px 0 2px",
        color: "white", borderColor: "white",
        "&.disabled": {
            background: "#727272",
            borderColor: "#727272",
            color: "#9c9c9c",
            pointerEvents: 'none',
        }
    },
    filterRow: {
        display: "inline-flex",
        alignItems: "center",
        width: "100%"
    },
    popoverClasses: {
      background: "red"
    },
    fullName: {
        display: "inline-block",
        marginLeft: 10,
        fontWeight: 300,
    },
    familyName: {
        fontWeight: "bold",
        textTransform: "uppercase",
        marginRight: 5,
    },
    vvip: {
        color: "#e46060",
        border: "1px solid #e46060",
        padding: "3px",
        fontSize: "10px",
        marginRight: "6px",
        borderRadius: "16px",
        verticalAlign: "middle",
        display: "inline-block",
        height: "20px"
    },
    patientsTable: {
        width: "97%",
        marginLeft: "20px",
        marginTop: "20px"
    },
    topBar: {
       // height: 100,
        position: "sticky",
        top: 0,
        background: theme.palette.background.paperSelected,
        zIndex: 99,
        padding: "5px 25px 5px 20px"
    },
    patientCountLabel:{
      fontSize: 14,
       // marginLeft: 10
    },
    searchButtons: {
        textAlign: 'center'
    },
    tableHeader: {
        backgroundColor: theme.palette.mode === 'light' ? '#e2e2e2' : '#363636',
        padding: "5px",
        marginBottom: "7px",
        color: "gray",
        fontSize: 12
    },
    tableRecord: {
        padding: "8px",
        marginBottom: "7px",
        backgroundColor: theme.palette.mode === 'light' ? '#cacaca' : '#434343',
        // backgroundColor: "rgb(67 67 67)",
        cursor: "pointer"
    },
    pagination: {
        width: "fit-content",
        margin: "auto"
    },
    fullNameHeader: {
        marginLeft: "10px"
    },
    sortedHeader: {
        cursor: "pointer"
    },
    buttonSelector: {
        borderRadius: 50,
        backgroundColor: theme.palette.grey["300"],
        color: "rgba(0, 0, 0, 0.87)",
        margin: "0 5px",
        fontSize: 10
    },
    headerText: {
        float: "left",
        marginTop: 4
    },
    menuIcon: {
        //position: "absolute",
        // top: 10
    },
    eyonixIcon: {
        position: "absolute",
        top: 10
    },
    divRow: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        marginLeft: "auto",
        marginRight: "auto",
    },
    filterNameInModal: {
        color: "#FFF",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: 32,
    },
    menuItemChip: {
        borderRadius: "38px",
        border: "1px solid #A4A7AB",
        background: "#3D3E40",
        width: 100,
        height: 32,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
            background: "#A4A7AB"
        },
        "&.selected": {
            background: "white",
            color: "black",
            fontWeight: 700
        }
    },
    modalButton: {
        width: "min-content",
        border: "1px solid white",
        cursor: "pointer",
        height: "32px",
        display: "flex",
        fontSize: "12px",
        background: "#616161",
        alignItems: "center",
        paddingLeft: "15px",
        borderRadius: "38px",
        paddingRight: "15px",
        justifyContent: "center",
        "&:hover": {
            background: "#A4A7AB"
        },
        "&.selected": {
            background: "white",
            color: "black",
            fontWeight: 700
        },
        "&.disabled": {
            color: "grey",
            pointerEvents: "none"
        }
    },
    clearButton: {
        borderRadius: "38px",
        border: "1px solid white",
        background: "white",
        width: 100,
        color: "#313233",
        height: 32,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
            background: "#A4A7AB",
            border: "1px solid #848589",
        },
        "&.disabled": {
            color: "#848589",
            pointerEvents: "none"
        }
    },
    modalBottomButtons: {
        display: "inline-flex",
        gap: "10px",
        justifyContent: "flex-end",
        position: "absolute",
        bottom: "0px",
        height: "50px",
        right: "20px",
        width: "100%",
        backgroundColor: theme.palette.mode === "dark" ? "#3D3E40 !important" : "#ebebeb !important",
        alignItems: "center"
    },
    groupTitle: {
        margin: "10px 20px",
        fontSize: theme.typography.h5.fontSize,
        userSelect: "none",
    },
    mainContainer: {
        height: "99vh",
        position: "relative"
    }
}));


function PatientsDocList(props) {
    const dispatch = useDispatch();
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    const filtersTypes = {
        all: 0,
        last30Days: 1,
        today: 2,
        last7Days: 3,
        last30records: 4,
        twoDays: 5,
        threeDays: 6,
        week: 7,
        tenDays: 8,
        month: 9,
        year: 10,
        last3years: 11,
        last5years: 12,
        notSet: 13
    }

    const mainFilters = [
        {
            label: "Last 30 records",
            value: filtersTypes.last30records
        },
        {
            label: "Today",
            value: filtersTypes.today
        },
        {
            label: "2 days",
            value: filtersTypes.twoDays
        },
        {
            label: "3 days",
            value: filtersTypes.threeDays
        },
        {
            label: "Week",
            value: filtersTypes.week
        },
        {
            label: "10 days",
            value: filtersTypes.tenDays
        },
        {
            label: "Month",
            value: filtersTypes.month
        },
        {
            label: "Year",
            value: filtersTypes.year
        },
        {
            label: "Last 3 years",
            value: filtersTypes.last3years
        },
        {
            label: "Last 5 years",
            value: filtersTypes.last5years
        },
        {
            label: "Not set",
            value: filtersTypes.notSet
        }
    ]

    const patientCurrentPreferencesObject = useSelector(patientCurrentPreferences);
    const canViewPatientRecord = dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD));

    const [patientsFiltered, setPatientsFiltered] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const [isFilterModalOpen, openFilterModal, closeFilterModal] = useOpenState(false, true);
    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);
    const [isModalNewFilterOpen, openModalNewFilter, closeModalNewFilter] = useOpenState(false, true);
    const [holdingPenDicts, setHoldingPenDicts] = React.useState([]);

    const [filters, setFilters] = React.useState(config.modules.admin.filters);
    const [mainFilter, setMainFilter] = useState(null);
    const [selectedFilterToUpdate, setSelectedFilterToUpdate] = useState(null);

    const [patientSearchText, setPatientSearchText] = useState("");
    const [studyViewMode, setStudyViewMode] = useState("list");
    const [patientIdToStudyMode, setPatientIdToStudyMode] = useState(null);
    const [searchOpen, setSearchOpen] = useState(false);
    const [newFilterName, setNewFilterName] = useState("")
    const patientPreferencesObject = useSelector(patientPreferences);

    const topBarRef = React.useRef(null);
    const smartFiltersSettings = useSelector(globalVariable("smartFiltersSettings"));
    const initRender = React.useRef(true);

    useEffect(() => {
        if(smartFiltersSettings && patientsFiltered.length > 0 && initRender.current) {
            setStudyViewMode(smartFiltersSettings.mode);
            const scrollDomObj = document.getElementById('smartFiltersList');
            if(scrollDomObj){
                scrollDomObj.scrollTop = smartFiltersSettings.scroll;
            }
            initRender.current = false;
        }
    }, [smartFiltersSettings, patientsFiltered]);

    useEffect(() => {
        if(!patientCurrentPreferencesObject.filtersDoc) handleSelect(mainFilters[1])
        let params = new URLSearchParams(window.location.search);
        let id = params.get("patientId");
        if(id) setPatientIdToStudyMode(id);

    },[])

    const getFilterValue = (field) => {
        return _.find(filters, {requestField : field})
    }

    const searchDocsPatients = () => {
        if(getFilterValue("from_date").__filterValue && getFilterValue("to_date").__filterValue) {

            let options = {
                "from_date": moment.utc(getFilterValue("from_date")?.__filterValue).startOf('day').toISOString(),
                "to_date": moment.utc(getFilterValue("to_date")?.__filterValue).endOf('day').toISOString(),
                "order": "!publishDate",
                "procedure" : getFilterValue("procedure")?.__filterValue,
                "operator": getFilterValue("operator")?.__filterValue,
                "location": getFilterValue("location")?.__filterValue,
            };

            if(patientCurrentPreferencesObject.showMode === 'Last 30 records') {
                options["pageSize"] = 30;
                options["page"] = 0;
            }

            API.getPatientsSmartFilter(options).then(res => {
                if (res.status === 200) {
                    setPatientsFiltered(_.filter(res.data.data, p => !_.isNull(p)));
                }
                if (res.status === 204)
                    setPatientsFiltered([]);
                if (res.status !== 200 && res.status !== 204) {
                    console.debug("API.getPatientsList request status : " + res.status);
                }
            }).finally(() => setLoading(false));
        }
    }

    const getProperFiltersValuesForSavedFilters = (filtersToSet, showMode) => {
        let showModelEl = mainFilters.find((el) => el.label === showMode);

        let amount = 0;
        let unit = "days";

        switch (showModelEl.value) {
            case filtersTypes.threeDays:
                amount = 3;
                unit = "days";
                break;
            case filtersTypes.twoDays:
                amount = -2;
                unit = "days";
                break;
            case filtersTypes.week:
                amount = -7;
                unit = "days";
                break;
            case filtersTypes.tenDays:
                amount = -10;
                unit = "days";
                break;
            case filtersTypes.month:
                amount = -1;
                unit = "month";
                break;
            case filtersTypes.today:
                amount = -1;
                unit = "days";
                break;
            case filtersTypes.year:
                amount = -1;
                unit = "year";
                break;
            case filtersTypes.last3years:
                amount = -3;
                unit = "year";
                break;
            case filtersTypes.last5years:
                amount = -5;
                unit = "year";
                break;
            case filtersTypes.last30records:
                amount = -10;
                unit = "year";
                break;
        }

        let fromDate = _.find(filtersToSet, {requestField: "from_date"});
        fromDate.__filterValue = moment().add(amount,unit).toISOString();

        let toDate = _.find(filtersToSet, {requestField: "to_date"});
        toDate.__filterValue = moment().toISOString();

        return filtersToSet;

    }

    const handleSetFilterSet = (filterName) => {
        if(filterName){
            let filterToSet = _.find(patientCurrentPreferencesObject?.filtersDocList, {name: filterName});
            if(filterToSet) {
                let data = _.cloneDeep(patientCurrentPreferencesObject);
                data.selectedFilterDocName = filterToSet.name;
                data.showMode = filterToSet.showMode;

                if(filterToSet.showMode !== "Not set") {
                    data.filtersDoc = getProperFiltersValuesForSavedFilters(_.cloneDeep(filterToSet.filters), filterToSet.showMode);
                } else {
                    data.filtersDoc = filterToSet.filters;
                }
                dispatch(setPatientCurrentPreference(data));
            }
        } else {
            handleSelect(mainFilters[1], true);
        }
    }

    const renderCustomOption = (opt, index) => {
        return <MenuItem key={opt?.name} value={opt?.name}>{t(opt?.name)}</MenuItem>
    }

    const setFiltersAndMainFilter = (fil) => {
        const filterCopy = _.cloneDeep(config.modules.admin.filters);
        let newFilters = fil.filtersDoc;

        if (newFilters !== filters) {
            _.forEach(newFilters, filter => {
                _.forEach(filterCopy, singleFilter => {
                    if (singleFilter._id === filter._id
                        && (!singleFilter.subtype || singleFilter.subtype === filter.subtype)) {
                        if (filter.__filterValue !== undefined)
                            singleFilter.__filterValue = moment.isMoment(filter.__filterValue) ? filter.__filterValue.toISOString() : filter.__filterValue;
                        else
                            delete singleFilter.__filterValue;
                    }
                });
            });
        }

        setFilters(filterCopy);
    }

    const handleSelect = (type, removeAll = false) => {
        setAnchorEl(null);
        let dateAfterFilterObj = getFilterValue("from_date");

        function changeDateFilter(amount, unit) {
            dateAfterFilterObj.__filterValue = moment().add(amount, unit).toISOString();
            changeFiltersForValue(dateAfterFilterObj, type.label, removeAll)
        }

        switch (type.value) {
            case filtersTypes.threeDays:
                changeDateFilter(-3, "days")
                break;
            case filtersTypes.twoDays:
                changeDateFilter(-2, "days")
                break;
            case filtersTypes.week:
                changeDateFilter(-7, "days")
                break;
            case filtersTypes.tenDays:
                changeDateFilter(-10, "days")
                break;
            case filtersTypes.month:
                changeDateFilter(-1, "month")
                break;
            case filtersTypes.today:
                changeDateFilter(-1, "days")
                break;
            case filtersTypes.year:
                changeDateFilter(-1, "year")
                break;
            case filtersTypes.last3years:
                changeDateFilter(-3, "year")
                break;
            case filtersTypes.last5years:
                changeDateFilter(-5, "year")
                break;
            case filtersTypes.last30records:
                changeDateFilter(-10, "year")
                break;
        }

        setMainFilter(type);
    };

    const filterChanged = (filter) => (value) => {
        const filterCopy = _.cloneDeep(filters);
        let data = _.cloneDeep(patientCurrentPreferencesObject);

        _.forEach(filterCopy, singleFilter => {
            if (singleFilter._id === filter._id && (!singleFilter.subtype || singleFilter.subtype === filter.subtype)) {
                if (value === undefined || (value && value.length === 0)) {
                    delete singleFilter.__filterValue;
                } else {
                    if(moment.isMoment(value)) {
                        singleFilter.__filterValue = value.toISOString();
                        data.showMode = "Not set";
                    } else {
                        if(!singleFilter.__filterValue)  singleFilter.__filterValue = [];
                        singleFilter.__filterValue.push(value);
                    }
                }
            }
        });

        data.filtersDoc = filterCopy;
        data.selectedFilterDocName = null;

        dispatch(setPatientCurrentPreference(data));
    };

    const changeFiltersForValue = (newFilter, type, removeAll = false) => {
        const filterCopy = _.cloneDeep(filters);

        _.forEach(filterCopy, singleFilter => {
            if (singleFilter._id === newFilter._id) {
                singleFilter.__filterValue = newFilter.__filterValue
            } else if(singleFilter.requestField === "to_date") {
                singleFilter.__filterValue = moment().toISOString();
            } else if(removeAll){
                delete singleFilter.__filterValue;
            }

        });

        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filtersDoc = filterCopy;
        data.showMode = type;
        data.selectedFilterDocName = null;
        dispatch(setPatientCurrentPreference(data));
    };

    const removeItemFilter = (filterToRemove) => (value) => {
        const filterCopy = _.cloneDeep(filters);

        _.forEach(filterCopy, filter => {
            if (filter.name === filterToRemove.name) {
                if(value && filter.__filterValue.length > 1){
                    let indexToRemove = filter.__filterValue.findIndex((v) => v === value);
                    filter.__filterValue.splice(indexToRemove, 1);
                } else {
                    delete filter.__filterValue
                }
            }
        });

        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filtersDoc = filterCopy;
        data.selectedFilterDocName = null;
        dispatch(setPatientCurrentPreference(data));
    };

    useEffect(() => {
        if(!patientCurrentPreferencesObject) {
            dispatch(cloneCurrentPref());
        } else if(patientCurrentPreferencesObject.filtersDoc) {
            setFiltersAndMainFilter(patientCurrentPreferencesObject);

            let showModelEl = mainFilters.find((el) => el.label === patientCurrentPreferencesObject.showMode);
            setMainFilter(showModelEl)
        }

    }, [patientCurrentPreferencesObject]);

    const prepareDictStruct = (inputData, displayField, groupBy) => {
        if(groupBy) {
            let t = inputData.filter((item) => item.hasOwnProperty(groupBy))
            return Object.groupBy(t, (item) => item[groupBy]);
        } else {
            return _.sortBy(inputData, [displayField]);
        }
    }

    useEffect(() => {
        if(filters){
            const dictFilters = filters;

            let dictFiltersPromises = [];
            let dictFiltersItems = [];
            let holdingPenFilterDicts = [];

            dictFilters.forEach((df => {
                if(df.hasOwnProperty("dictUrl")){
                    dictFiltersPromises.push(API.getDictByURL(df.dictUrl));
                    dictFiltersItems.push(df);
                }
            }));

            Promise.all(dictFiltersPromises).then(dicts => {
                for(let i = 0; i < dictFiltersItems.length; i++){
                    holdingPenFilterDicts.push({
                        filterId: dictFiltersItems[i]._id,
                        dict: prepareDictStruct(dicts[i].__data, dictFiltersItems[i].displayField, dictFiltersItems[i].groupByField),
                        displayField: dictFiltersItems[i].displayField
                    });
                }
                setHoldingPenDicts(holdingPenFilterDicts);
            });
        }
        dispatch(setGlobalVariable({
            name: "openInAdminContext",
            value: false,
        }));

    }, []);

    const searchPatients = () => {
        let options = {
            resourceUri: "/patients",
            text: patientSearchText,
            page: 1,
            pageSize: config.modules.patients.pageSize,
            options: {},
        }

        API.getSearchList(options).then(res => {
            if (res.status === 200) {
                setPatientsFiltered(_.filter(res.data.collection['__data'], p => !_.isNull(p)));
            }
            if (res.status === 204)
                setPatientsFiltered([]);
            if (res.status !== 200 && res.status !== 204) {
                console.debug("API.getPatientsList request status : " + res.status);
            }
        }).finally(() => setLoading(false));

    }

    useEffect(() => {
        if(filters && patientSearchText === ""){
            searchDocsPatients();
        } else if(patientSearchText !== "" && patientSearchText.length > 2) {
            searchPatients()
        }
    }, [filters, patientSearchText]);

    const searchSet = () => {
        return patientSearchText.length > 2;
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleNewPatientToView = (newId) => {
        setPatientIdToStudyMode(newId)
    }

    const changeCurrentPreferencesForNewFilter = (newFilterToSave) => {
        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filtersDocList.push(newFilterToSave);
        data.selectedFilterDocName = newFilterName;

        dispatch(setPatientCurrentPreference(data));
    }

    const updateCurrentPreferencesForNewFilter = () => {
        let data = _.cloneDeep(patientCurrentPreferencesObject);
        let filterIndexToEdit = _.findIndex(data.filtersDocList, {id: selectedFilterToUpdate.id})

        data.filtersDocList[filterIndexToEdit] = {
            ...data.filtersDocList[filterIndexToEdit],
            filters: filters,
            showMode: patientCurrentPreferencesObject.showMode
        };

        data.selectedFilterDocName = data.filtersDocList[filterIndexToEdit].name;

        dispatch(setPatientCurrentPreference(data));
    }

    const saveNewFilterInPreferences = (newFilterToSave) => {
        let data = _.cloneDeep(patientPreferencesObject);
        data.filtersDocList.push(newFilterToSave);
        dispatch(savePref(data, {noUpdateCurrent: true}));
    }

    const updateNewFilterInPreferences = () => {
        let data = _.cloneDeep(patientPreferencesObject);
        let filterIndexToEdit = _.findIndex(data.filtersDocList, {id: selectedFilterToUpdate.id})

        data.filtersDocList[filterIndexToEdit] = {
            ...data.filtersDocList[filterIndexToEdit],
            filters: filters,
            showMode: patientCurrentPreferencesObject.showMode
        };

        dispatch(savePref(data, {noUpdateCurrent: true}));
    }

    const createNewFilterItemToSave = () => {
        return {
            id: uuid(),
            name: newFilterName,
            filters: filters,
            showMode: mainFilter.label
        }
    }

    const handleSaveFilters = () => {
        const newFilterToSave = createNewFilterItemToSave();

        saveNewFilterInPreferences(newFilterToSave);
        changeCurrentPreferencesForNewFilter(newFilterToSave)

        setNewFilterName("");
        closeModalNewFilter();
        closeModal();
    };

    const handleUpdateFilters = () => {
        updateNewFilterInPreferences();
        updateCurrentPreferencesForNewFilter()
        setSelectedFilterToUpdate(null);
        closeModal();
    };

    const renderNewFilterModal = () => {
        return  <Dialog open={isModalNewFilterOpen} onClose={closeModalNewFilter}>
            <DialogTitle>Create smart filter</DialogTitle>
            <DialogContent>

                <TextField
                    autoFocus
                    margin="dense"
                    value={newFilterName}
                    onChange={(evt) => { setNewFilterName(evt.target.value) }}
                    label="Filter Name"
                    fullWidth
                    variant="standard"
                />

            </DialogContent>
            <DialogActions>
                <div className={clsx(classes.modalButton)} style={{minWidth: 100}} onClick={closeModalNewFilter}>Cancel</div>
                <div className={clsx(classes.clearButton, (newFilterName.length < 3 || patientPreferencesObject.filtersDocList.some((f)=> f.name === newFilterName)) && "disabled")}
                     style={{minWidth: 100}}
                     onClick={handleSaveFilters}>Save</div>
            </DialogActions>
        </Dialog>

    }

    const renderSmartFiltersModal = () => {
        return  <AgyleDialog
            contentStyle={classes.dialogContentStyle}
            title={"Smart filters"}
            onClose={closeFilterModal}
            fullWidth
            width={"md"}
            titleStyle={classes.titleStyleDialog}
            disableActions
            closeButtonOnHeader
            open={isFilterModalOpen}>

            <div>
                <Grid container alignItems={"flex-start"} spacing={2} style={{marginBottom: 40}}>
                    <Grid item xs={2}>
                        <div className={classes.filterNameInModal}> Show </div>
                    </Grid>
                    <Grid item xs={10}>
                        <div style={{display: "inline-flex", gap: 15, flexWrap: "wrap"}}>
                            {mainFilters.map((filter) => {
                                return <div className={clsx(classes.menuItemChip, mainFilter?.label === filter.label && "selected" )}
                                            onClick={handleSelect.bind(this, filter, false)}>{filter.label}</div>
                            })}

                        </div>

                    </Grid>
                    {filters.map((filter) => {
                        return <Grid item xs={filter.type === "date"? 6 : 4}>
                            <EyonixFilterButton
                                fullView
                                onChange={filterChanged(filter)}
                                onRemove={removeItemFilter(filter)}
                                config={{
                                    name: t(filter.name),
                                    filter: filter,
                                }}
                                filtersValues={filter.__filterValue}
                                data={holdingPenDicts.find((el) => el.filterId === filter._id)}
                                dataFieldToRender={holdingPenDicts.find((el) => el.filterId === filter._id)?.displayField}
                                field={filter._id}/>
                        </Grid>
                    })}

                </Grid>
                <div className={classes.modalBottomButtons}>
                    <div className={clsx(classes.menuItemChip)} onClick={openModal}>
                        Save filter
                    </div>
                    <div className={clsx(classes.clearButton)}
                         onClick={()=>{handleSetFilterSet("")}}>
                        Clear All
                    </div>
                </div>
            </div>
        </AgyleDialog>
    }

    const renderTopBar = () => {
        return  <div className={classes.topBar} ref={topBarRef}>
            <Grid container alignItems={"center"} spacing={0}>

                <Grid item xs={3} style={{display: "flex", alignItems: "center", gap: 10}}>
                    <AgyleSelectField
                        label={t("Selected filter")}
                        style={{
                            height: '100%',
                            minHeight: '36px'
                        }}
                        onChange={(filterName) => {
                            handleSetFilterSet(filterName)
                        }}
                        disabled={searchSet()}
                        withBackground
                        withBorder
                        defaultClearValue={""}
                        customObject={renderCustomOption}
                        options={patientCurrentPreferencesObject?.filtersDocList}
                        value={patientCurrentPreferencesObject?.selectedFilterDocName}
                    />

                    <IconButton size="small"
                                onClick={openFilterModal}
                                disabled={searchSet()}
                                style={{minWidth: "0"}}>
                        <FilterIcon3 />
                    </IconButton>

                    {!patientCurrentPreferencesObject?.selectedFilterDocName && (filters.some((f) => f.__filterValue)) &&
                    <div style={{display: "inline-block"}}>
                        <IconButton size="small"
                                    onClick={()=>{
                                        if(patientCurrentPreferencesObject.filtersDocList && patientCurrentPreferencesObject.filtersDocList.length){
                                            openModal()
                                        } else {
                                            openModalNewFilter()
                                        }
                                    }}
                                    disabled={searchSet()}
                                    style={{minWidth: "0"}}>
                            <SaveIcon2 className={classes.removeIcon}/>
                        </IconButton>
                    </div>}
                </Grid>
                <Grid item xs>
                    <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-end", gap: 10}}>
                        <div className={clsx(classes.filterItem, classes.filtersBlockGroup)}>
                            <Tooltip title="" placement="top">
                                <div className={clsx(classes.groupedButton, searchSet() && "disabled")}
                                     onClick={handleClick}>
                                            <span>
                                                Show: <b>{mainFilter ? mainFilter.label : 'Not set2'} </b>
                                            </span>
                                </div>
                            </Tooltip>

                            <Menu
                                id="simple-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                placement="bottom-end"
                                PaperProps={{
                                    elevation: 0,
                                    className: 'scroll-normal-white',
                                    sx: {
                                        overflow: "visible",
                                        borderRadius: '8px',
                                        backgroundColor: "rgba(61, 62, 64, 1)"
                                    },
                                }}
                            >
                                {mainFilters.map((filter)=>{
                                    return <MenuItem className={classes.menuItem}
                                                     onClick={handleSelect.bind(this, filter, false)}>{filter.label}</MenuItem>
                                })}
                            </Menu>
                        </div>
                        {filters.map((filter) => {
                            let renderedChips = [];

                            renderedChips.push(<EyonixFilterButton
                                onChange={filterChanged(filter)}
                                onRemove={removeItemFilter(filter)}
                                config={{
                                    name: t(filter.name),
                                    filter: filter,
                                }}
                                disabled={searchSet()}
                                filtersValues={filter.__filterValue}
                                data={holdingPenDicts.find((el) => el.filterId === filter._id)}
                                dataFieldToRender={holdingPenDicts.find((el) => el.filterId === filter._id)?.displayField}
                                field={filter._id}
                                dontCloseOnChoose={true}/>)

                            return <div> {renderedChips} </div>
                        })}
                    </div>

                </Grid>
                <Grid item xs={12}>
                    <div style={{marginTop: 5}}>
                        <Grid container justifyContent={"space-between"} alignItems="center">
                            <Grid item>
                            <span className={classes.patientCountLabel}>
                                Patients found: {patientsFiltered.length}
                            </span>

                            </Grid>
                            <Grid item >
                                <div style={{display: "inline-flex", gap: 10, alignItems: "flex-end", height: 39}}>
                                    {searchOpen &&
                                        <AgyleTextField
                                            inputPropsClasses={classes.searchText}
                                            textFieldClass={classes.textField}
                                            size="small"
                                            fullWidth
                                            variant="contained"
                                            onChange={(e)=>{ setPatientSearchText(e.target.value) }}
                                            value={patientSearchText}
                                            noBorder={false}
                                            startAdornment={<SearchIcon style={{marginRight: 8}}/>}
                                            endAdornment={<CloseIcon style={{marginRight: 8, cursor: "pointer"}} onClick={()=>{
                                                setPatientSearchText("")
                                                setSearchOpen(false);
                                            }}/>}
                                            shrink
                                            smallerPlaceholder
                                            style={{marginBottom: 5}}
                                        />
                                    }
                                    {!searchOpen && <IconButton
                                        size="small"
                                        onClick={() => {
                                            setSearchOpen(true)
                                        }}
                                        variant="outlined"
                                    >
                                        <SearchIcon/>
                                    </IconButton>
                                    }
                                    <AgyleBlockSwitch
                                        onChange={(e)=>{setStudyViewMode(e)}}
                                        value={studyViewMode}
                                        nullState={null}
                                        valueObject={{"true": "list", "false": "box"}}
                                        // style={{marginRight: 10}}
                                        customLabels={{
                                            yes: <AgyleMapViewIcon/>,
                                            no: <AgyleBoundingBoxIcon/>,
                                        }}
                                    />
                                </div>

                            </Grid>
                        </Grid>
                    </div>


                </Grid>
            </Grid>
        </div>
    }

    const renderSaveFilterModal = () => {
        return  <Dialog maxWidth={"xs"} open={isModalOpen} onClose={closeModal}>
            <DialogTitle style={{display: "flex", gap: "50px", justifyContent: "space-between"}}>
                Save Smart Filter
                <div className={clsx(classes.clearButton)} onClick={openModalNewFilter}>
                    <AddIcon fontSize={"small"}/>
                    <span>New</span>
                </div>
            </DialogTitle>
            <DialogContent>
                {patientCurrentPreferencesObject?.filtersDocList.map((filter) => {
                    return <div className={classes.filterRow} onClick={()=>{ setSelectedFilterToUpdate(filter) }}>
                        <Checkbox style={{ padding: "5px 10px 5px 0", color: "white"}} checked={selectedFilterToUpdate === filter}/>
                        <div> {filter.name} </div>
                    </div>
                })}
            </DialogContent>
            <DialogActions>
                <div className={clsx(classes.modalButton)} style={{minWidth: 100}} onClick={closeModal}>Cancel</div>
                <div className={clsx(classes.clearButton, !selectedFilterToUpdate && "disabled")} style={{minWidth: 100}} onClick={handleUpdateFilters}>Save</div>
            </DialogActions>
        </Dialog>
    }

    return <div className = {classes.mainContainer}>

        {isModalNewFilterOpen && renderNewFilterModal()}
        {isModalOpen && renderSaveFilterModal()}

        {isFilterModalOpen && renderSmartFiltersModal()}

        {renderTopBar()}

        <div style={{height: studyViewMode === "box"? patientIdToStudyMode? `calc(50% - ${(topBarRef.current?.clientHeight/2)+1}px)` : `calc(90% - ${(topBarRef.current?.clientHeight + 1)}px)` : `calc(100% - ${(topBarRef.current?.clientHeight + 1)}px)`, padding: "0 10px 10px 10px"}}
             className={'scroll-normal-white'} id="smartFiltersList">
            <ListPatientsWithDocs
                patientsFiltered={patientsFiltered}
                searchSet={searchSet()}
                studyViewMode = {studyViewMode}
                patientToViewStudy={handleNewPatientToView}
                patientToView={patientIdToStudyMode}/>
        </div>

        {studyViewMode === "box" && patientIdToStudyMode && canViewPatientRecord &&
            <div style={{height: `calc(50% - ${(topBarRef.current?.clientHeight/2) + 1}px)`, overflow: "hidden"}}>
                <PatientVIPEyonixGuard
                    forwardComponent={<PatientDetails patientIdOpenFromAdmin={patientIdToStudyMode} adminPageMode={studyViewMode}/>}
                    patientIdOpenFromAdmin={patientIdToStudyMode}/>
            </div>
        }

    </div>
};

export default PatientsDocList;